export default "__VITE_ASSET__CwFCYBuF__"